export default {
  methods: {
    roundName(list, i) {
      const round = list[i];
      let matches = round ? round.matches : 0;
      //fix for round name if there is a third place match
      if (matches === 2 && i === list.length - 1) {
        matches -= 1;
      }
      return matches < 1
        ? this.$t('_web_tournaments-tableview_wrong-round', 'wrong round')
        : matches < 2
        ? this.$t('_web_tournaments-tableview_final', 'Final')
        : matches < 3
        ? this.$t('_web_tournaments-tableview_semifinal', 'Semifinal')
        : '1/' +
          matches +
          ' ' +
          this.$t('_web_tournaments-tableview_round', 'round');
    },
  },
};
